import { render, staticRenderFns } from "./TrafficViolationHistoryDelivery.vue?vue&type=template&id=14192059"
import script from "./TrafficViolationHistoryDelivery.vue?vue&type=script&lang=js"
export * from "./TrafficViolationHistoryDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports